export const buildQueryKey = (args: {
  queryKey: string | (string | number)[] | number;
  venueID: string | number;
  params: unknown;
}) => {
  const { queryKey, venueID, params } = args;
  const venueSpecificParams = {
    ...(venueID ? { venueId: venueID } : {}),
  };
  return [
    ...(Array.isArray(queryKey) ? queryKey : [queryKey]),
    venueSpecificParams,
    params,
  ];
};
